import React from 'react';
import PropTypes from 'prop-types';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import Modal from '@src/custom/modal-window';

import {
    DateField,
    TextField,
} from 'react-admin';

const RevisionHistoryPopup = (props) => {
    const { modalOpen, handleClose, recordRevisions } = props;

    return (
        <Modal
            open={modalOpen}
            title="Revision History"
            onClose={handleClose}
        >
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Updated By</TableCell>
                            <TableCell>Date/time updated</TableCell>
                            <TableCell>Version Description</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            recordRevisions.map((rr) => {
                                return (
                                    <TableRow key={rr.id}>
                                        <TableCell>
                                            <TextField
                                                label="Order"
                                                record={rr}
                                                source="user_name"
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <DateField
                                                showTime
                                                record={rr}
                                                source="created_at"
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                label="Order"
                                                record={rr}
                                                source="description"
                                            />
                                        </TableCell>
                                    </TableRow>
                                );
                            })
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </Modal>
    );
};

RevisionHistoryPopup.propTypes = {
    modalOpen: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    recordRevisions: PropTypes.array.isRequired,
};

export default RevisionHistoryPopup;
